var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.125 15H14.875C13.8203 15 13 15.8594 13 16.875V28.125C13 29.1797 13.8203 30 14.875 30H31.125C32.1406 30 33 29.1797 33 28.125V16.875C33 15.8594 32.1406 15 31.125 15ZM31.125 16.875V18.4766C30.2266 19.2188 28.8203 20.3125 25.8516 22.6562C25.1875 23.1641 23.8984 24.4141 23 24.375C22.0625 24.4141 20.7734 23.1641 20.1094 22.6562C17.1406 20.3125 15.7344 19.2188 14.875 18.4766V16.875H31.125ZM14.875 28.125V20.8984C15.7344 21.6016 17.0234 22.6172 18.9375 24.1406C19.7969 24.8047 21.3203 26.2891 23 26.25C24.6406 26.2891 26.125 24.8047 27.0234 24.1406C28.9375 22.6172 30.2266 21.6016 31.125 20.8984V28.125H14.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWhite);
export default __webpack_public_path__ + "static/media/message-white.29c4b48d8ad7df2bab148bf9f91d31ec.svg";
export { ForwardRef as ReactComponent };